import React, { forwardRef, useState } from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const ProjectCard = forwardRef(({ project }, ref) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };
  return (
    <article
      id={project.id}
      className={`project-card mb-4 lg:mb-6 ${isHovered ? "hovered" : ""}`}
      ref={ref}
    >
      <Link
        to={`/project/${project.slug}`}
        data-cursor-text="View"
        data-cursor-size="60"
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        <div className="flex flex-col">
          <h4 className="mb-4 uppercase leading-none text-[clamp(1.44rem,1.3824rem+0.288vw,1.728rem)]">
            {project.title}
          </h4>
          {project.show_video === true ||
          (project.gallery === null && project.video) ? (
            <div className="video-container">
              <iframe
                title={project.title}
                src={`https://player.vimeo.com/video/${project.video}?muted=1&autoplay=1&loop=1&autopause=0&background=1:`}
                className={`pointer-events-none aspect-video w-full ${
                  isHovered && "rounded-md"
                }`}
              ></iframe>
            </div>
          ) : (
            project.gallery !== null && (
              <GatsbyImage
                className={`image-container ${isHovered && "rounded-md"}`}
                image={getImage(project.gallery[0].localFile)}
                imgStyle={{
                  maxWidth: 800,
                  maxHeight: "100%",
                  margin: "0 auto",
                }}
                alt={project.gallery[0].alternativeText || "PPT4U Image"}
                loading="eager"
              />
            )
          )}
        </div>
      </Link>
    </article>
  );
});

export default ProjectCard;
